angular.module('eStories.compnt.carousel', [
    'eStories.grid-4-carousel.compnt',
    'eStories.grid-6-carousel.compnt',
    'eStories.grid-12-carousel.compnt',
    'eStories.collapsed-feature-carousel.compnt',
    'eStories.feature-carousel.compnt',
    'eStories.static-end-cap.compnt',
    'eStories.half-end-cap.compnt',
    'eStories.grid-title.compnt',
    'eStories.see-all-link.compnt',
    'eStories.end-cap-deal.compnt',
    'eStories.rotating-carousel.cmpnt'
]);
 